import { ILeagueEntry } from "core-integration/src/store/entries/types";
import { IH2HMatch } from "core-integration/src/store/leagues/types";
import { Row } from "plos/src/components/Table";
import { cellStyles } from "plos/src/components/Table/tables.css";
import Link from "plos/src/components/links/Link";
import { Cell } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { getShortNameFromId } from "../../../../utils/events";
import { getCupUrl } from "../../../leagues/utils";
import { CupStatusCell } from "./CupStatusCell";
import { generalCellStyles } from "./cupTypeTable.css";

interface ICupTypeRowProps {
  cupMatch: IH2HMatch | null;
  entryId: number;
  league: ILeagueEntry;
}

const CupTypeRow = ({ cupMatch, entryId, league }: ICupTypeRowProps) => {
  const { t } = useTranslation("leaguesAndCups");
  return (
    <Row>
      <Cell className={cellStyles}>
        <Link to={getCupUrl(league.id, league.cup_league, entryId)}>
          {t("myCups.cupName", "{{leagueName}} cup", {
            leagueName: league.name,
          })}
        </Link>
      </Cell>
      {cupMatch && league.cup_qualified ? (
        <>
          <Cell className={generalCellStyles}>
            {getShortNameFromId(cupMatch.event)}
          </Cell>
          <CupStatusCell cupMatch={cupMatch} entryId={entryId} />
        </>
      ) : (
        <>
          <Cell className={generalCellStyles}>&nbsp;</Cell>
          <Cell className={generalCellStyles}>&nbsp;</Cell>
        </>
      )}
    </Row>
  );
};

export default CupTypeRow;
